class CustomReview {
	static url = "https://cf7ugo55qcfsqi7ocl6nsox3cy0swofz.lambda-url.us-east-1.on.aws/api/v1";
	static SupportedCountries = ["GB", "IE"];
	static config = undefined;

	static async init() {
		if (this.initStatus) return this.initStatus;
		this.initStatus = (async () => {
			// TODO retry logic
			let response = await fetch(`${this.url}/global`);
			if (!response.ok) {
				console.error("Failed to fetch global config");
				return;
			}
			let data = await response.json();
			if (!data.success) {
				console.error("Failed to fetch global config");
				return;
			}

			this.ratings = data.ratings;
			this.stats = data.stats;
			this.total = data.total;
			this.config = data.config;
			this.initStatus = true;
			return true;
		})();
		return this.initStatus;
	}

	/**
	 * @param {number} productID
	 * @param {string} country
	 * @returns {Promise<{rating: number, count: number}>}
	 * */
	static async getRating(productID, country) {
		await this.init();
		country = country.toUpperCase();

		if (!this.SupportedCountries.includes(country)) {
			country = "ROW";
		}

		if (!this.ratings) {
			console.error("Ratings not initialized");
			return null;
		}

		if (!this.ratings[productID]) {
			let parts = productID.split("-");
			let rawProductID = parts.slice(0, -1).join("-");
			if (this.ratings[rawProductID]) {
				productID = rawProductID;
			}
			// if the product has no reviews return default rating
			if (
				this.ratings[productID] === undefined ||
				this.ratings[productID][country] === undefined ||
				this.ratings[productID][country].count === 0
			) {
				return {
					rating: 5,
					count: this.stats[country].count,
				};
			}
		}

		if (!this.ratings[productID][country]) {
			console.error("Country not found");
			return null;
		}

		if (this.config.reviewStarsCount === "country") {
			return {
				rating: this.ratings[productID][country].rating,
				count: this.stats[country].count,
			};
		} else if (this.config.reviewStarsCount === "global") {
			return {
				rating: this.ratings[productID][country].rating,
				count: this.total.enabled,
			};
		} else {
			return this.ratings[productID][country];
		}

		return this.ratings[productID][country];
	}

	/**
	 * @param {string} order - "latest" or "featured"
	 * @param {number} productID 
	 * @param {string} country 
	 * @param {number} limit
	 * @param {string} after
	 * @returns {Promise<{reviews: Array, next: string, total: number}>}
	 */
	static async getReviews(order, productID, country, limit, after) {
		await this.init();
		let fetchAll = productID === "*";
		if (this.config.alwaysShowGlobalReviews === true) {
			fetchAll = true;
		}
		country = country.toUpperCase();

		if (!this.SupportedCountries.includes(country)) {
			country = "ROW";
		}

		if (!fetchAll && !this.ratings[productID]) {
			let parts = productID.split("-");
			let rawProductID = parts.slice(0, -1).join("-");
			if (this.ratings[rawProductID]) {
				productID = rawProductID;
			}
			// if the product has no reviews show all reviews
			if (
				this.ratings[productID] === undefined ||
				this.ratings[productID][country] === undefined ||
				this.ratings[productID][country].count === 0
			) {
				if (this.config.defaultGlobalReviews === true) {
					fetchAll = true;
				} else {
					console.warn("Product reviews not found");
					return null;
				}
			}
		}

		if (!fetchAll && !this.ratings[productID][country]) {
			console.error("Country not found");
			return null;
		}

		let params = this.params({
			country: country,
			limit: limit,
			after: after,
			order: order
		});
		let response = await fetch(`${this.url}/${fetchAll ? "products" : `product/${productID}`}?${params}`);
		if (!response.ok) {
			console.error("Failed to fetch reviews");
			return null;
		}
		let data = await response.json();
		if (!data.success) {
			console.error("Failed to fetch reviews");
			return null;
		}

		let total;
		let rating;
		if (fetchAll) {
			total = this.stats[country] ? this.stats[country].count : 0;
		} else {
			if (this.config.reviewListCount === "country") {
				total = this.stats[country].count;
			} else if (this.config.reviewListCount === "global") {
				total = this.total.enabled;
			} else {
				total = this.ratings[productID] ? this.ratings[productID][country].count : 0;
			}
			rating = this.ratings[productID] ? this.ratings[productID][country].rating : 5;
		}
		return {
			reviews: data.reviews,
			next: data.next,
			// total: this.ratings[productID][country].count,
			total: total,
			rating: rating,
		};
	}

	static renderStars(rating, loaded) {
		let stars = [];
		for (let i = 0; i < 5; i++) {
			let percent = Math.max(rating - i, 0);
			percent = Math.min(percent, 1);
			stars.push(this.renderStar(percent, loaded));
		}
		return stars;
	}

	static renderStar(percent, loaded) {
		let imgSrc;
		if (percent > 0.95) {
			imgSrc = "https://cdn.shopify.com/s/files/1/0631/2732/2872/files/star-full.png?v=1745862197";
		} else if (percent >= 0.55) {
			imgSrc = "https://cdn.shopify.com/s/files/1/0631/2732/2872/files/star-three-quarter.png?v=1745862196";
		} else if (percent >= 0.5 && percent <= 0.55) {
			imgSrc = "https://cdn.shopify.com/s/files/1/0631/2732/2872/files/star-half.png?v=1745862196";
		} else if (percent < 0.5 && percent > 0.05) {
			imgSrc = "https://cdn.shopify.com/s/files/1/0631/2732/2872/files/star-quarter-to.png?v=1745862197";
		} else {
			imgSrc = "https://cdn.shopify.com/s/files/1/0631/2732/2872/files/star-blank.png?v=1745862197";
		}
		let img = document.createElement("img");
		img.src = imgSrc;
		img.classList.add("_star");
		if (!loaded) {
			img.style.opacity = "0.5";
		}
		return img;
	}

	static params(data) {
		for (const [key, value] of Object.entries(data)) {
			if (value == null || value === "") {
				delete data[key];
			}
		}
		return new URLSearchParams(data);
	}
}

const reviewStarsStyle = new CSSStyleSheet();
reviewStarsStyle.replaceSync(`
	review-stars {
		display: flex;
		align-items: center;
		width: max-content;
	}
	review-stars ._rating {
		display: inline-block;
		height: 30px;
		font-size: 21px;
		width: 41px;
		text-align: center;
	}
	review-stars ._stars {
		display: inline-block;
		height: 22px;
		padding-top: 2px;
	}
	review-stars ._star {
		width: 18px;
		height: 18px;
	}
	review-stars ._reviews {
		display: inline-block;
		height: 22px;
		padding-left: 10px;
		font-size: 16px;
	}
`);
document.adoptedStyleSheets.push(reviewStarsStyle);

class CustomReviewStars extends HTMLElement {
	constructor() {
		super();
	}

	async connectedCallback() {
		this.productID = this.getAttribute("product");
		this.country = this.getAttribute("country") ?? review_iso_code;

		this.render(5, "loading", false);

		this.data = await CustomReview.getRating(this.productID, this.country);
		if (!this.data) {
			// this.innerHTML = "Failed to load reviews";

			this.render(5, "0", false);
			return;
		}

		this.render(this.data.rating, this.data.count, true);
	}

	render(rating, count, loaded) {
		let ratingElement = document.createElement("span");
		ratingElement.classList.add("_rating");
		ratingElement.innerText = loaded ? rating.toFixed(1) : "";
		let starsElement = document.createElement("span");
		starsElement.classList.add("_stars");
		starsElement.append(...CustomReview.renderStars(rating, loaded));

		let reviewsElement = document.createElement("span");
		reviewsElement.classList.add("_reviews");
		let reviewsUnderlinedElement = document.createElement("u");
		reviewsUnderlinedElement.innerText = count + " reviews";
		reviewsElement.append(reviewsUnderlinedElement);

		this.replaceChildren(ratingElement, starsElement, reviewsElement);
	}
}

customElements.define("review-stars", CustomReviewStars);

let reviewListStyle = new CSSStyleSheet();
reviewListStyle.replaceSync(`
	.jdgm-rev-widg__summary {
		display: none !important;
	}

	review-list {
		max-width: 1544px;
		display: block;
		margin: 0 auto;
		box-sizing: border-box;
	}

	review-list ._summary {
		margin: 0 auto;
		width: calc(100% - 33px);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 16px;
		background-color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}

	review-list ._summary ._rating {
		display: inline-block;
		height: 30px;
		font-size: 21px;
		text-align: center;
		padding-left: 10px;
	}
	review-list ._summary ._stars {
		display: inline-block;
		height: 22px;
		padding-top: 2px;
	}
	review-list ._summary ._star {
		width: 18px;
		height: 18px;
	}
	review-list ._summary ._reviews {
		display: inline-block;
		height: 22px;
		padding-left: 10px;
		font-size: 19px;
	}

	review-list ._review-list {
		width: 100%;
		padding: 0 20px;
		display: flex;
		justify-content: center;
		gap: 16px;
		flex-wrap: wrap;
		box-sizing: border-box;
	}

	review-list ._order-selector {
		margin: 10px 0 10px 20px;
		padding: 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		font-size: 16px;
		background-color: #fff;
	}

	review-list button {
		display: block;
		margin: 10px auto;
		padding: 10px 20px;
		background-color: var(--color-button-primary-background);
		color: var(--color-button-primary-text);
		border: none;
		border-radius: var(--border-radius-button);
		cursor: pointer;
		font-size: 16px;
	}
	
	review-list ._review {
		width: calc(33.3% - 11px);
		border-radius: 8px;
		padding: 16px;
		background-color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}

	review-list ._review-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	review-list ._stars {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	review-list ._star {
		width: 18px;
		height: 18px;
	}

	review-list ._reviewer-name {
		font-weight: bold;
		font-size: 16px;
		margin: 4px 0;
	}

	review-list ._verified {
		font-size: 14px;
		color: #888;
	}

	review-list ._review-title {
		font-size: 18px;
		font-weight: bold;
		margin: 4px 0;
	}

	review-list ._review-body {
		font-size: 16px;
		color: #333;
		margin: 8px 0;
	}

	review-list ._review-body ._review-image {
		text-align: center;
	}

	review-list ._review-body ._review-image img {
		max-width: 100%;
		max-height: 300px;
		border-radius: 8px;
	}

	@media(max-width: 900px) {
		review-list ._review-list {
			flex-direction: row;
		}
		review-list ._review {
			width: calc(50% - 11px);
		}
	}

	@media(max-width: 600px) {
		review-list ._review-list {
			flex-direction: column;
		}
		review-list ._review {
			width: 100%;
		}
	}
`);
document.adoptedStyleSheets.push(reviewListStyle);

class CustomReviewList extends HTMLElement {
	constructor() {
		super();
	}

	async connectedCallback() {

		this.productID = this.getAttribute("product");
		this.country = this.getAttribute("country") ?? review_iso_code;
		this.limit = parseInt(this.getAttribute("limit")) || 6;
		this.after = null;
		this.reviews = [];
		this.total = 0;
		this.loaded = false;

		this.renderLoading();

		await CustomReview.init();
		this.order = CustomReview.config.defaultOrder ?? "featured";
		if (await this.fetchReviews()) {
			this.renderReviews();
		}
	}

	async fetchReviews() {
		this.data = await CustomReview.getReviews(this.order, this.productID, this.country, this.limit, this.after);
		if (!this.data) {
			this.renderNoReviews();
			return false;
		}
		this.after = this.data.next;
		this.reviews = this.data.reviews;
		this.total = this.data.total;
		this.rating = this.data.rating;
		this.loaded = true;
		return true;
	}

	renderLoading() {
		this.innerHTML = "Loading reviews...";
	}

	renderSummary() {
		let summaryElement = document.createElement("div");
		summaryElement.classList.add("_summary");

		{
			let starsWrapperElement = document.createElement("div");

			let starsElement = document.createElement("span");
			starsElement.classList.add("_stars");
			starsElement.append(...CustomReview.renderStars(this.rating, this.loaded));

			let ratingElement = document.createElement("span");
			ratingElement.classList.add("_rating");
			ratingElement.innerText = this.loaded ? (this.rating.toFixed(2) + " out of 5") : "";

			starsWrapperElement.append(starsElement, ratingElement);

			let reviewsWrapperElement = document.createElement("div");

			let reviewsElement = document.createElement("span");
			reviewsElement.classList.add("_reviews");
			reviewsElement.innerText = "Based on " + (this.total ?? 0) + " reviews";

			reviewsWrapperElement.append(reviewsElement);

			summaryElement.replaceChildren(starsWrapperElement, reviewsWrapperElement);
		}

		return summaryElement;
	}

	renderOrderSelector() {
		let orderSelectorElement = document.createElement("select");
		orderSelectorElement.classList.add("_order-selector");
		orderSelectorElement.addEventListener("change", async (event) => {
			if (event.target.value === this.order) return;
			this.order = event.target.value;
			this.after = null;
			this.reviews = [];
			this.total = 0;
			this.querySelector("._review-list").innerHTML = "Loading reviews...";
			this.querySelector("._load-more")?.remove();
			if (await this.fetchReviews()) {
				this.renderReviews();
			}
		});
		let options = [
			{ value: "featured", label: "Featured" },
			{ value: "latest", label: "Latest" }
		];
		for (const option of options) {
			let optionElement = document.createElement("option");
			optionElement.value = option.value;
			optionElement.innerText = option.label;
			if (option.value === this.order) {
				optionElement.selected = true;
			}
			orderSelectorElement.appendChild(optionElement);
		}
		return orderSelectorElement;
	}

	renderReviews() {
		let reviewListElement = document.createElement("div");
		reviewListElement.classList.add("_review-list");
		if (!this.loaded) {
			this.renderLoading();
			return;
		}
		for (const data of this.reviews) {
			reviewListElement.appendChild(this.renderReview(data));
		}

		let orderSelectorElement = this.renderOrderSelector();
		if (this.productID !== "*" && this.total > 0 && this.rating !== undefined) {
			let summaryElement = this.renderSummary();
			this.replaceChildren(summaryElement, orderSelectorElement, reviewListElement);
		} else {

			this.replaceChildren(orderSelectorElement, reviewListElement);
		}

		if (this.reviews.length < this.total) {
			let loadMoreButton = document.createElement("button");
			loadMoreButton.classList.add("_load-more");
			loadMoreButton.innerText = "Load more reviews";
			loadMoreButton.addEventListener("click", () => {
				this.fetchReviews().then(() => this.renderReviews());
			});
			this.appendChild(loadMoreButton);
		}
	}

	renderReview(data) {
		let reviewElement = document.createElement("div");
		reviewElement.classList.add("_review");

		let headerElement = document.createElement("div");
		headerElement.classList.add("_review-row");
		{
			let starsElement = document.createElement("div");
			starsElement.classList.add("_stars");
			starsElement.append(...CustomReview.renderStars(data.rating, true));

			if (CustomReview.config.showDate === true) {
				let dateElement = document.createElement("div");
				dateElement.classList.add("_date");
				// print date as "dd/mm/yy"
				let date = new Date(data.createdAt);
				dateElement.innerText = date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" });

				headerElement.append(starsElement, dateElement);
			} else {
				headerElement.appendChild(starsElement);
			}
		}

		let reviewerElement = document.createElement("div");
		reviewerElement.classList.add("_review-row");
		{
			let reviewerNameElement = document.createElement("div");
			reviewerNameElement.classList.add("_reviewer-name");
			reviewerNameElement.innerText = data.review.reviewer;

			if (CustomReview.config.showVerified === true) {
				let verifiedElement = document.createElement("div");
				verifiedElement.classList.add("_verified");
				verifiedElement.innerText = data.review.verified ? "Verified" : "Not Verified";

				reviewerElement.append(reviewerNameElement, verifiedElement);
			} else {
				reviewerElement.appendChild(reviewerNameElement);
			}
		}

		let reviewTitleElement = document.createElement("div");
		reviewTitleElement.classList.add("_review-title");
		reviewTitleElement.innerText = data.review.title ?? "";

		let reviewBodyElement = document.createElement("div");
		reviewBodyElement.classList.add("_review-body");

		{
			let media = [
				...(data.review.videos ?? []).filter(video => !video.hidden).map(video => ({
					kind: "video",
					...video
				})),
				...(data.review.pictures ?? []).filter(picture => !picture.hidden).map(picture => ({
					kind: "image",
					...picture
				}))
			];
			if (media.length > 0) {
				let mediaElement = document.createElement("div");
				mediaElement.classList.add("_review-image");
				media.forEach(item => {
					let mediaItem;
					if (item.kind === "video") {
						if (item.type === "vimeo") {
							mediaItem = document.createElement("iframe");
							mediaItem.src = `https://player.vimeo.com/video/${item.id}`;
							mediaItem.setAttribute("allow", "autoplay; fullscreen");
							mediaItem.setAttribute("allowfullscreen", "");
						} else if (item.type === "youtube") {
							mediaItem = document.createElement("iframe");
							mediaItem.src = `https://www.youtube.com/embed/${item.id}`;
							mediaItem.setAttribute("allow", "autoplay; encrypted-media");
							mediaItem.setAttribute("allowfullscreen", "");
						} else if (item.type === "videodelivery") {
							mediaItem = document.createElement("iframe");
							mediaItem.src = `https://iframe.videodelivery.net/${item.id}`;
							mediaItem.setAttribute("allow", "autoplay; encrypted-media");
							mediaItem.setAttribute("allowfullscreen", "");
						} else if (item.type === "custom") {
							mediaItem = document.createElement("video");
							mediaItem.src = item.url;
							mediaItem.controls = true;
						} else {
							console.warn("Unknown video type", item.type);
							return;
						}
						mediaItem.style.width = "100%";
						mediaItem.style.height = "300px";
						mediaItem.style.borderRadius = "8px";
					} else if (item.kind === "image") {
						mediaItem = document.createElement("img");
						mediaItem.src = item.urls.huge;
						mediaItem.alt = item.alt || "Review image";
					}
					mediaItem.style.maxWidth = "100%";
					mediaItem.style.maxHeight = "300px";
					mediaItem.style.borderRadius = "8px";
					mediaElement.appendChild(mediaItem);
				});
				reviewBodyElement.appendChild(mediaElement);
			}

		}
		reviewBodyElement.append(data.review.body);

		reviewElement.append(headerElement, reviewerElement, reviewTitleElement, reviewBodyElement);
		return reviewElement;
	}

	renderNoReviews() {
		let reviewListElement = document.createElement("div");
		reviewListElement.classList.add("_review-list");

		let reviewElement = document.createElement("div");
		reviewElement.classList.add("_review");
		reviewElement.innerText = "No reviews found";
		reviewListElement.appendChild(reviewElement);

		if (this.productID !== "*" && this.total > 0) {
			let summaryElement = this.renderSummary();
			this.replaceChildren(summaryElement, reviewListElement);
		} else {
			this.replaceChildren(reviewListElement);
		}
	}
}

customElements.define("review-list", CustomReviewList);
